/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { BannerComponentEditor } from "./edit";
import { BannerComponentDisplay } from "./display";

const BannerComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <BannerComponentDisplay />,
        editComponent: <BannerComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

BannerComponent.displayName = "BannerComponent";
export { BannerComponent };
